module.exports = __webpack_public_path__ + "img/br23.3e98fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br23.jpg
// module id = OK2f
// module chunks = 0